var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"dense":"","small":"","color":"black"}},[_vm._v(" fa-"+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }